import type { IEntityModel } from './base'

export enum IQuestionnaireDisplayRuleConditionInputNumberOperator {
  Equal = '=',
  GreaterThan = '>',
  LessThan = '<',
  GreaterThanOrEqual = '>=',
  LessThanOrEqual = '<=',
}

export interface IQuestionnaireDisplayRuleConditionInputNumber
  extends IEntityModel {
  displayRuleConditionId: string
  operator: IQuestionnaireDisplayRuleConditionInputNumberOperator
  value: number
}
